/* eslint-disable new-parens */
import { createRowEntity } from './row';

class EntityFactory {
  create (Entity, entityData) {
    return new Entity(entityData);
  }

  createRow (Entity, entityData, rowData) {
    return new (createRowEntity(Entity, entityData, rowData));
  }
}

const entityFactory = new EntityFactory();

export default entityFactory;
